import { Button, Flex } from '@chakra-ui/react';
import useAppDispatch from 'hooks/shared/store/useAppDispatch';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import AlertModal from 'presentation/components/shared/modals/AlertModal';
import {
  ButtonSize,
  ButtonVariant,
} from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLogoutMutation } from 'rtkQuery/sharespro/queries/login';
import { authSlice } from 'slices/modules/auth/authSlice';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const LogoutConfirmModal: FC<Props> = ({ onClose, isOpen }) => {
  const { t } = useTranslation();

  const [logout, { isLoading: isLoggingOut }] = useLogoutMutation();

  const dispatch = useAppDispatch();

  return (
    <>
      <AlertModal
        title={t('attention')}
        text={t('areYouSureYouWanToLogout')}
        isOpen={isOpen}
        onClose={onClose}
        footer={
          <Flex>
            <Button
              variant={ButtonVariant.Ghost}
              mr={3}
              size={ButtonSize.sm}
              onClick={onClose}
            >
              {t('cancelAction')}
            </Button>
            <Button
              size={ButtonSize.sm}
              onClick={() => {
                logout()
                  .unwrap()
                  .finally(() => {
                    dispatch(authSlice.actions.logout());
                    onClose();
                  });
              }}
            >
              {t('confirm')}
            </Button>
          </Flex>
        }
      />
      <FullScreenLoader isLoading={isLoggingOut} />
    </>
  );
};

export default LogoutConfirmModal;
